<template>

    <div class="mlpo">

        <div class="mlpo__header" v-show="$mq !== 'sm'">
            <img src="/img/magic/logo.svg" class="mlpo__header__logo" @click="goLanding">
        </div>

        <div class="mlpo__body">
            <div v-if="step === ENUMSTATE.LOADING" class="mlpo__loading">

                <LottieLoader :size="30"></LottieLoader>

            </div>
            <div v-if="isStateResponse" class="mlpo__bloc">

                <div class="mlpo__bloc__top">

                    <img :src="computedImage" class="img__96">

                    <p class="mlpo__bloc__title">{{ computedTitle }}</p>

                    <p class="mlpo__bloc__text">{{ computedText }}</p>

                </div>

                <div class="mlpo__bloc__bottom">

                    <button class="mlpo__bloc__cta" @click="action">{{ computedCta }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vuex from 'vuex'

import Storage from '@/helpers/storage'

import Auth from '@/modules/auth'
import Tag from '@/modules/tag'
import UserFlow from '@/modules/userFlow'

import LottieLoader from '@/components/lottie/LottieLoader'
import Impressum from '@/views/Impressum'
import CookieLaw from '@/components/CookieLaw'

export default {

    name: 'magic-link-post',

    components: {CookieLaw, Impressum, LottieLoader},

    watch: {

        step: function (step) {

            switch (step) {
                case this.ENUMSTATE.LOADING:
                    UserFlow.setPage(this, 'magic_loader')
                    break
                case this.ENUMSTATE.SUCCESS:
                    UserFlow.setPage(this, 'magic_success')
                    break
                case this.ENUMSTATE.ERROR:
                    UserFlow.setPage(this, 'magic_error')
                    break
                case this.ENUMSTATE.TIME_OUT:
                    UserFlow.setPage(this, 'magic_timeout')
                    break
            }

        }
    },

    computed: {
        isStateResponse() {
            return this.step === this.ENUMSTATE.SUCCESS || this.step === this.ENUMSTATE.ERROR || this.step === this.ENUMSTATE.TIME_OUT
        },

        computedImage() {
            switch (this.step) {
                case this.ENUMSTATE.SUCCESS:
                    return '/img/magic/illustration-welcome-back.svg'
                case this.ENUMSTATE.ERROR:
                    return '/img/magic/illustration-technical-error.svg'
                case this.ENUMSTATE.TIME_OUT:
                    return '/img/magic/illustration-link-expired.svg'
            }
        },

        computedTitle() {
            switch (this.step) {
                case this.ENUMSTATE.SUCCESS:
                    return this.$tc('magic_success_title_hello_personal', 0, {first_name: this.firstname})
                case this.ENUMSTATE.ERROR:
                    return this.$t('magic_error_title')
                case this.ENUMSTATE.TIME_OUT:
                    return this.$t('magic_link_expired_title')
            }
        },

        computedText() {
            switch (this.step) {
                case this.ENUMSTATE.SUCCESS:
                    return this.$t('magic_link_reconnected')
                case this.ENUMSTATE.ERROR:
                    return this.$t('magic_error_subtitle')
                case this.ENUMSTATE.TIME_OUT:
                    return this.$t('magic_link_expired_description')
            }
        },

        computedCta() {
            switch (this.step) {
                case this.ENUMSTATE.SUCCESS:
                    return this.$t('fetch_cta')
                case this.ENUMSTATE.ERROR:
                    return this.$t('magic_error_cta')
                case this.ENUMSTATE.TIME_OUT:
                    return this.$t('magic_timeout_cta')
            }
        }
    },

    data() {

        return {
            ENUMSTATE: {
                LOADING: 'loading',
                SUCCESS: 'success',
                ERROR: 'error',
                TIME_OUT: 'timeOut',
            },
            step: '',
            code: '',
            error: '',
            firstname: ''
        }

    },

    mounted() {

        // When user click on email, "disconnect" him before send request for magic link
        Storage.removeItem('token')

        this.goStep(this.ENUMSTATE.LOADING)

        this.code = this.$route.query.code
        this.error = this.$route.query.error

        if (!this.code) {

            this.$router.push({path: '/'})

        } else {
            this.runRequest()
        }


    },

    methods: {

        ...Vuex.mapActions(['setUser']),

        goStep(step) {
            this.step = step
        },

        runRequest() {

            //if "getMagicUser" launch in mounted, "code" is sometimes empty
            if (this.$route.name === 'magic-link') {

                this.getMagicUser()

            } else {

                this.getAuthLink()

            }
        },

        getMagicUser() {

            Auth.getMagicLinkUser(this.code)
                .then(data => {

                    this.successRequest(data)

                })
                .catch(error => {

                    this.errorRequest(error)

                })

        },

        getAuthLink() {

            Auth.getAuthLink(this.code)
                .then(data => {

                    this.successRequest(data)

                })
                .catch(error => {

                    this.errorRequest(error)

                })

        },

        successRequest(data) {

            if (data && data.result && data.result.token) {

                this.setUser(data.result.user)
                this.firstname = data.result.user.firstname
                Storage.setItem('token', data.result.token)
                this.goStep(this.ENUMSTATE.SUCCESS)


            } else {

                this.goStep(this.ENUMSTATE.ERROR)
                Tag.pageViewAmplitude(this, 'magic_error')
            }

        },

        errorRequest(error) {

            if (error && error.message === 'timeout') {

                this.goStep(this.ENUMSTATE.TIME_OUT)

            } else {

                Tag.pageViewAmplitude(this, 'magic_error')
                this.goStep(this.ENUMSTATE.ERROR)
            }

        },

        action() {
            switch(this.step) {
                case this.ENUMSTATE.SUCCESS:
                    this.$router.push({path: '/fetch'})
                    break
                case this.ENUMSTATE.TIME_OUT:
                    Tag.clickAmplitude(this, 'next')
                    this.$router.push({path: '/magic-request-email'})
                    break
                case this.ENUMSTATE.ERROR:
                    this.$router.push({path: '/login/email'})
                    break
            }
        },

        goLanding() {
            this.$router.push({path: '/'})
        }

    }

}
</script>

<style lang="scss" scoped>

.mlpo {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__header {
        width: 100%;
        padding: 22px;
        display: flex;
        justify-content: center;

        &__logo {
            height: 20px;
            object-fit: contain;
            cursor: pointer;
        }
    }

    &__body {
        width: 100%;
        display: flex;
        flex-grow: 1;
        @media screen and (min-width: $above-mobile-length) {
            align-items: center;
            justify-content: center;
            background-color: $mint;
        }
    }

    &__loading {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        height: 100%;
    }

    &__bloc {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        flex-grow: 1;
        text-align: left;
        padding: 48px 24px 24px;
        @media screen and (min-width: $above-mobile-length) {
            max-width: 400px;
            border-radius: 12px;
            text-align: center;
            background-color: $white;
        }

        &__title {
            margin-top: 32px;
            font-size: 24px;
            font-weight: 600;
            line-height: 1.17;
        }

        &__text {
            margin-top: 12px;
            font-size: 17px;
            line-height: 1.41;
        }

        &__top {
            @media screen and (min-width: $above-mobile-length) {
                width: 100%;
            }
        }

        &__bottom {
            width: 100%;
            text-align: center;
            @media screen and (min-width: $above-mobile-length) {
                margin-top: 32px;
            }
        }

        &__cta {
            padding: 20px;
            width: 100%;
            background-color: $blue;
            border-radius: 32px;

            font-size: 16px;
            font-weight: 600;
            line-height: 1;
            color: $white;
        }
    }
}
</style>
